import { useNavigate, NavigateFunction, useLocation } from "react-router-dom";
import { CLOSE_WARNING } from "../../consts";
import { Button, ButtonProps } from "../mui";
import { SxProps } from "@mui/material";

export const CloseButton = (
  props: ButtonProps & {
    confirm?: boolean;
    onClick?: () => void;
    theme?: "Dark" | "Standard";
  }
) => {
  const navigate = useNavigate();

  const location = useLocation();
  const hasDialog = location.pathname.includes('dialog');

  const handleClose = (confirm?: boolean) => {
    if (confirm) {
      if (window.confirm(CLOSE_WARNING) === true) {
        if (props.onClick) props.onClick();
        else navigate(`../`);
      }
    } else {
      if (props.onClick) props.onClick();
      else navigate(`../`);
    }
  };

  const { confirm, onClick, theme, ...rest } = props;

    const darkModeStyle: SxProps = ({
      color: "#eff3ff",
      backgroundColor: props.disabled ? "#08519c" : "#08519c", 
      border: "1px solid #eff3ff",
      fontWeight: 600,
      opacity: props.disabled ? 0.85 : 1, // subtle fade
      cursor: props.disabled ? "default" : "pointer",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.1)",
        borderColor: "#eff3ff",
      }
  });

  return (
    <Button sx={theme == "Dark" || hasDialog ? {...darkModeStyle, ...props.sx} : {...props.sx}} onClick={() => handleClose(confirm)} variant="outlined" {...rest}>
      Close
    </Button>
  );
};

export const handleClose = (nav: NavigateFunction, confirm?: boolean) => {
  if (confirm) {
    if (window.confirm(CLOSE_WARNING) === true) {
      nav(`../`);
    }
  } else {
    nav(`../`);
  }
};
